<template lang="pug">
popup(
  v-model="show",
  position="bottom",
  @close="$emit('close')",
)
  .content(style="background: #fff")
    .header Bank Name
    .fieldWrap
      field.pickerField(
        clearable,
        right-icon="search",
        @input="input",
        @focus="focus",
        placeholder="Search Bank",
        v-model="inputValue"
      )
    picker.commonPicker(
      ref="picker",
      visible-item-count="5",
      :columns="nowColumns",
      :default-index="defaultIndex",
      value-key="label",
      :loading="loading",
      @change="change",
      @confirm="confirm",
      @cancel="cancel"
    )
</template>
<script>
import { Popup, Picker, Field } from 'vant'
export default {
  name: 'CommonSearchPicker',
  components: {
    Popup,
    Picker,
    Field
  },
  props: {
    value: { type: Boolean, default: false },
    defaultIndex: { type: [String, Number], default: 0 },
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: { type: Boolean, default: true }
  },
  data () {
    return {
      inputValue: '',
      nowColumns: []
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  watch: {
    columns () {
      this.$set(this, 'nowColumns', this.columns)
    },
    inputValue (e) {
      this.input(e)
    }
  },

  methods: {
    toggleShowSearch () {
      this.$emit('toggle-search', true) // 或者 false，根据需要切换
    },
    upconfirm () {
      this.$refs.picker.confirm()
    },
    hshsh () {
      this.inputValue = ''
    },
    confirm (value, index) {
      this.$emit('change', value)
      this.show = false
      this.inputValue = ''
    },
    cancel () {
      this.show = false
      this.inputValue = ''
    },
    input (v) {
      this.$set(
        this,
        'nowColumns',
        this.columns.filter((item) => item.label.indexOf(v.toUpperCase()) > -1)
      )
    },
    change () {},
    focus () {
      this.$emit('focus')
    }
  }
}
</script>
<style scoped lang="less">
.fieldWrap {
  text-align: right;
  margin: 12px 13px 0;
  border: 1px solid #C4C4C4;
  border-radius: 8px;
  margin-top: 20px;
}
::v-deep .van-icon-search {
  font-size: 20px;
}
::v-deep .van-picker-column__item--selected:before {
  content: "";
  width: 15px;
  height: 12px;
  display: inline-block;
  background-image: url("../assets/pickerTrue.png");
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  right: 0.3rem;
}
.header {
  font-size: 16px;
  color: #12033a;
  font-weight: 500;
}
.pickerField {
  border-radius: 0.2rem;
}
::v-deep .pickerField {
  background: #f6f6f6 !important;
}
.van-popup {
  width: 100% !important;
  background: #fff !important;
  border-radius: 20px 20px 0px 0px;
}
.content {
  padding-top: 19px;
  border-radius: 0.3rem;
}
.commonPicker {
  /deep/ .van-ellipsis {
    width: 300px;
    white-space: break-spaces;
  }
}
</style>
